import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.presentation.detail');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-presentation-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.presentation.detail/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fafaf9;
}

.detail-wrap {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.project-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 24px;
  border-bottom: 1px solid #e4e4e7;
  background: #fff;
}

.project-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #52525b;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.project-tab:hover {
  background: #f4f4f5;
  color: #18181b;
}

.project-tab.is-active {
  border-color: rgba(37, 99, 235, 0.18);
  background: rgba(37, 99, 235, 0.06);
  color: #2563eb;
}

.project-tab i {
  font-size: 11px;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}`],
})
export class PagePresentationDetailComponent implements OnInit, OnDestroy {
    public deck: any = null;
    public slides: any[] = [];
    public currentSlide: any = null;
    public currentIndex: number = 0;
    public loading: boolean = true;
    public deckId: string = '';

    public generating: boolean = false;
    public generatingOutline: boolean = false;
    public generationProgress: number = 0;
    public generationMsg: string = '';
    public regenLoadingId: string = '';

    public showSpeakerNote: boolean = false;
    public previewUrl: string = '';
    public safePreviewUrl: SafeResourceUrl | null = null;
    public previewTab: 'html' | 'pdf' = 'html';
    public pdfPreviewUrl: string = '';
    public safePdfPreviewUrl: SafeResourceUrl | null = null;
    public pdfPreviewLoading: boolean = false;

    // 인플레이스 편집 모드
    public htmlEditMode: boolean = false;
    public editablePreviewUrl: string = '';
    public safeEditablePreviewUrl: SafeResourceUrl | null = null;
    public htmlEditSaving: boolean = false;
    private _editMessageHandler: ((e: MessageEvent) => void) | null = null;

    // 우측 패널 탭 (편집 / AI 채팅)
    public rightTab: 'edit' | 'chat' = 'edit';
    public chatMessages: { role: 'user' | 'assistant'; text: string }[] = [];
    public chatInput: string = '';
    public chatLoading: boolean = false;

    @ViewChild('previewArea', { static: false }) previewArea: ElementRef | null = null;
    @ViewChild('previewWrap', { static: false }) previewWrap: ElementRef | null = null;
    @ViewChild('previewIframe', { static: false }) previewIframe: ElementRef | null = null;
    private _resizeObs: ResizeObserver | null = null;

    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public async ngOnInit() {
        await this.service.init();
        this.deckId = WizRoute.segment.id;
        await this.load();
    }

    public ngOnDestroy() {
        if (this._resizeObs) {
            try { this._resizeObs.disconnect(); } catch (e) { }
            this._resizeObs = null;
        }
    }

    private _injectFitWidthMode(doc: Document) {
        if (!doc) return;
        if (doc.getElementById('__fit_width_mode_style')) return;
        const style = doc.createElement('style');
        style.id = '__fit_width_mode_style';
        // PDF 뷰어 스타일: 모든 .slide를 세로로 쌓고 iframe 너비에 맞춤 + 세로 스크롤
        style.textContent = `
            html, body {
                width: auto !important; height: auto !important;
                margin: 0 !important; padding: 0 !important;
                background: #525659 !important;
                overflow-x: hidden !important;
                overflow-y: auto !important;
            }
            body { padding: 16px 0 !important; display: block !important; }
            .slide, .slide ~ .slide {
                display: flex !important;
                margin: 0 auto 16px auto !important;
                box-shadow: 0 4px 16px rgba(0,0,0,0.4) !important;
            }
        `;
        doc.head.appendChild(style);
    }

    private _applyFitWidth() {
        if (!this.previewIframe) return;
        const iframe = this.previewIframe.nativeElement as HTMLIFrameElement;
        if (!iframe) return;
        const win = iframe.contentWindow;
        const doc = win?.document;
        if (!doc || !win) return;
        const slides = doc.querySelectorAll<HTMLElement>('.slide');
        if (slides.length === 0) return;
        const vw = win.innerWidth || 1;
        const padX = 32;
        const naturalWidth = slides[0].offsetWidth || 960;  // .slide 원본 너비 (254mm ≈ 960px)
        const scale = Math.min((vw - padX) / naturalWidth, 1.0);
        (doc.body.style as any).zoom = String(scale);
    }

    public onPreviewLoad() {
        if (!this.previewIframe) return;
        const iframe = this.previewIframe.nativeElement as HTMLIFrameElement;
        const sync = () => {
            try {
                const win = iframe.contentWindow;
                const doc = win?.document;
                if (!doc || !win) return;
                this._injectFitWidthMode(doc);
                if (!(win as any).__previewResizeBound) {
                    (win as any).__previewResizeBound = true;
                    win.addEventListener('resize', () => this._applyFitWidth());
                }
                this._applyFitWidth();
            } catch (e) { /* cross-origin or not ready */ }
        };
        sync();
        setTimeout(sync, 800);
        setTimeout(sync, 2000);
        if (!this._resizeObs && typeof ResizeObserver !== 'undefined' && this.previewArea) {
            this._resizeObs = new ResizeObserver(() => this._applyFitWidth());
            this._resizeObs.observe(this.previewArea.nativeElement);
        }
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const res = await wiz.call('load', { deck_id: this.deckId });
        if (res.code === 200) {
            this.deck = res.data.deck;
            this.slides = res.data.slides || [];
            // 진입 시 cover 슬라이드 중 body_html이 비어있는 것들은 모두 기본 HTML로 채워둔다
            await this._prefillEmptyCovers();
            if (this.slides.length > 0) {
                this.selectSlide(this.currentIndex < this.slides.length ? this.currentIndex : 0);
            }
        } else {
            await this.service.modal.show({ title: '오류', message: res.data?.message || '로드 실패', cancel: false, action: '확인' });
            this.service.href('/presentation');
            return;
        }
        this.loading = false;
        await this.service.render();
        // 초기 진입 시 미리보기 자동 로드 (슬라이드가 있을 때만)
        if (this.slides.length > 0) {
            await this.refreshPreview();
        }
    }

    private async _prefillEmptyCovers() {
        for (const s of this.slides) {
            if (s.layout !== 'cover') continue;
            if ((s.body_html || '').trim()) continue;
            try {
                const r = await wiz.call('snapshot_slide', { deck_id: this.deckId, slide_id: s.id });
                if (r.code !== 200) continue;
                s.body_html = r.data.html || '';
                await wiz.call('save_slide', {
                    deck_id: this.deckId, slide_id: s.id,
                    title: s.title || '', subtitle: s.subtitle || '',
                    body_html: s.body_html, speaker_note: s.speaker_note || '',
                });
            } catch (e) { /* noop */ }
        }
    }

    public selectSlide(idx: number) {
        if (idx < 0 || idx >= this.slides.length) return;
        this.currentIndex = idx;
        this.currentSlide = this.slides[idx];
        this.service.render();
        // iframe 안에서 해당 슬라이드로 스크롤
        this._scrollToSlide(idx);
        // 표지(cover) 재이아웃이 아직 body_html이 비어있으면 기본 HTML을 자동으로 채움
        this._ensureCoverHtml();
    }

    private async _ensureCoverHtml() {
        const s = this.currentSlide;
        if (!s) return;
        if (s.layout !== 'cover') return;
        if ((s.body_html || '').trim()) return;
        try {
            const res = await wiz.call('snapshot_slide', { deck_id: this.deckId, slide_id: s.id });
            if (res.code !== 200) return;
            // 선택이 그사이 바뀌었으면 무시
            if (this.currentSlide !== s) return;
            s.body_html = res.data.html || '';
            await wiz.call('save_slide', {
                deck_id: this.deckId,
                slide_id: s.id,
                title: s.title || '',
                subtitle: s.subtitle || '',
                body_html: s.body_html,
                speaker_note: s.speaker_note || '',
            });
            await this.service.render();
        } catch (e) { /* noop */ }
    }

    private _scrollToSlide(idx: number) {
        if (!this.previewIframe) return;
        const iframe = this.previewIframe.nativeElement as HTMLIFrameElement;
        try {
            const doc = iframe.contentWindow?.document;
            if (!doc) return;
            const slides = doc.querySelectorAll<HTMLElement>('.slide');
            const target = slides[idx];
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) { /* noop */ }
    }

    private _editTimer: any = null;
    public onEditChange() {
        // 편집 입력 시 디바운스로 프리뷰 자동 갱신
        if (this._editTimer) clearTimeout(this._editTimer);
        this._editTimer = setTimeout(async () => {
            if (!this.currentSlide) return;
            try {
                await wiz.call('save_slide', {
                    deck_id: this.deckId,
                    slide_id: this.currentSlide.id,
                    title: this.currentSlide.title || '',
                    subtitle: this.currentSlide.subtitle || '',
                    body_html: this.currentSlide.body_html || '',
                    speaker_note: this.currentSlide.speaker_note || '',
                });
                await this.refreshPreview();
            } catch (e) { /* noop */ }
        }, 500);
    }

    public layoutLabel(layout: string): string {
        const map: any = {
            'cover': '표지', 'agenda': '목차', 'section-divider': '챕터',
            'bullet': 'Bullet', 'two-column': '2단', 'table': '표', 'diagram': '도식',
            'closing': '마무리'
        };
        return map[layout] || layout;
    }

    public layoutClass(layout: string): string {
        const map: any = {
            'cover': 'bg-stone-800 text-white',
            'agenda': 'bg-blue-100 text-blue-700',
            'section-divider': 'bg-indigo-100 text-indigo-700',
            'bullet': 'bg-stone-100 text-stone-600',
            'two-column': 'bg-emerald-50 text-emerald-600',
            'table': 'bg-amber-50 text-amber-600',
            'diagram': 'bg-violet-50 text-violet-600',
            'closing': 'bg-stone-800 text-white',
        };
        return map[layout] || 'bg-stone-100 text-stone-500';
    }

    public async generateOutline() {
        if (this.slides.length > 0) {
            const ok = await this.service.modal.show({
                title: '구성 다시 만들기',
                message: '현재 모든 슬라이드가 삭제되고 새로 구성됩니다. 계속할까요?',
                cancel: '취소', action: '진행', actionBtn: 'error'
            });
            if (!ok) return;
        }
        this.generatingOutline = true;
        this.generationMsg = 'AI가 발표 구성을 설계하는 중...';
        await this.service.render();

        const res = await wiz.call('generate_outline', { deck_id: this.deckId });
        this.generatingOutline = false;
        if (res.code !== 200) {
            await this.service.modal.show({ title: '오류', message: res.data?.message || '실패', cancel: false, action: '확인' });
            await this.service.render();
            return;
        }
        await this.load();
        // 구성 완료 후 본문 생성을 자동 트리거
        try { await this.generateSlides(); } catch (_) {}
    }

    public async generateSlides() {
        if (this.slides.length === 0) {
            await this.service.modal.show({ title: '안내', message: '먼저 [구성 만들기]를 실행하세요.', cancel: false, action: '확인' });
            return;
        }
        this.generating = true;
        this.generationProgress = 0;
        this.generationMsg = '본문 생성 시작...';
        await this.service.render();

        const formData = new FormData();
        formData.append('deck_id', this.deckId);

        try {
            const response = await fetch(`/wiz/api/page.presentation.detail/generate_slides`, {
                method: 'POST', body: formData
            });
            if (!response.ok || !response.body) {
                throw new Error('SSE 연결 실패');
            }
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';
                for (const line of lines) {
                    if (!line.startsWith('data: ')) continue;
                    try {
                        const ev = JSON.parse(line.slice(6));
                        if (ev.type === 'slide_done') {
                            const target = this.slides.find(s => s.id === ev.slide_id);
                            if (target) {
                                target.body_html = ev.body;
                                target.status = 'ready';
                            }
                            this.generationProgress = Math.round(ev.done * 100 / ev.total);
                            this.generationMsg = `${ev.done}/${ev.total} 슬라이드 작성 완료`;
                            await this.service.render();
                        } else if (ev.type === 'done') {
                            this.generationMsg = '완료';
                            this.generationProgress = 100;
                        } else if (ev.type === 'error') {
                            console.warn('slide error', ev);
                        }
                    } catch (e) {
                        console.warn('SSE parse', e, line);
                    }
                }
            }
        } catch (e: any) {
            await this.service.modal.show({ title: '오류', message: e?.message || '생성 실패', cancel: false, action: '확인' });
        }
        this.generating = false;
        await this.load();
    }

    public async regenerateCurrent() {
        if (!this.currentSlide) return;
        if (this.currentSlide.layout === 'agenda') {
            await this.service.modal.show({ title: '안내', message: '목차 슬라이드는 재생성할 수 없습니다.', cancel: false, action: '확인' });
            return;
        }
        this.regenLoadingId = this.currentSlide.id;
        await this.service.render();
        const res = await wiz.call('regenerate_slide', { deck_id: this.deckId, slide_id: this.currentSlide.id });
        this.regenLoadingId = '';
        if (res.code !== 200) {
            await this.service.modal.show({ title: '오류', message: res.data?.message || '실패', cancel: false, action: '확인' });
            await this.service.render();
            return;
        }
        this.currentSlide.body_html = res.data.body_html;
        this.currentSlide.status = 'ready';
        await this.refreshPreview();
        await this.service.render();
    }

    public async saveCurrent() {
        if (!this.currentSlide) return;
        const res = await wiz.call('save_slide', {
            deck_id: this.deckId,
            slide_id: this.currentSlide.id,
            title: this.currentSlide.title || '',
            subtitle: this.currentSlide.subtitle || '',
            body_html: this.currentSlide.body_html || '',
            speaker_note: this.currentSlide.speaker_note || '',
        });
        if (res.code !== 200) {
            await this.service.modal.show({ title: '저장 실패', message: res.data?.message || '실패', cancel: false, action: '확인' });
        }
        await this.refreshPreview();
    }

    public async deleteCurrent() {
        if (!this.currentSlide) return;
        const ok = await this.service.modal.show({
            title: '슬라이드 삭제', message: '현재 슬라이드를 삭제할까요?',
            cancel: '취소', action: '삭제', actionBtn: 'error'
        });
        if (!ok) return;
        const res = await wiz.call('delete_slide', { deck_id: this.deckId, slide_id: this.currentSlide.id });
        if (res.code === 200) {
            await this.load();
        }
    }

    // ── 슬라이드 첨부 이미지 (유사사업 스크린샷 등)
    public uploading: boolean = false;
    public async uploadSlideImage(event: any) {
        if (!this.deckId) return;
        const files: FileList = event?.target?.files;
        if (!files || files.length === 0) return;
        const caption = (window.prompt('이미지 설명(캡션) - 비워두면 생략', '') || '').trim();
        const titleInput = (window.prompt('새 슬라이드 제목', caption || '참고 이미지') || '').trim();
        const kind = 'similar_project';
        this.uploading = true;
        try {
            const fd = new FormData();
            fd.append('deck_id', this.deckId);
            // 현재 슬라이드 다음에 새 본문 슬라이드로 추가 (cover/section/agenda여도 끼워넣지 않음)
            if (this.currentSlide && this.currentSlide.id) fd.append('slide_id', this.currentSlide.id);
            fd.append('caption', caption);
            fd.append('title', titleInput);
            fd.append('kind', kind);
            for (let i = 0; i < files.length; i++) fd.append('file', files[i]);
            const resp = await fetch('/wiz/api/page.presentation.detail/upload_slide_image', { method: 'POST', body: fd, credentials: 'same-origin' });
            const data = await resp.json();
            if (data.code === 200) {
                const newId = data.data?.slide_id;
                await this.load();
                if (newId) {
                    const idx = this.slides.findIndex((s: any) => s.id === newId);
                    if (idx >= 0) this.selectSlide(idx);
                }
                await this.refreshPreview();
            } else {
                try { await this.service.toast.error(data.data?.message || data.message || '업로드 실패'); } catch (_) {}
            }
        } finally {
            this.uploading = false;
            try { event.target.value = ''; } catch (_) {}
            await this.service.render();
        }
    }

    public async removeSlideImage(filename: string) {
        if (!this.currentSlide || !filename) return;
        const ok = await this.service.modal.show({
            title: '이미지 삭제', message: '이 이미지를 슬라이드에서 제거할까요?',
            cancel: '취소', action: '삭제', actionBtn: 'error'
        });
        if (!ok) return;
        const res = await wiz.call('delete_slide_image', { deck_id: this.deckId, slide_id: this.currentSlide.id, filename });
        if (res.code === 200) {
            this.currentSlide.images = res.data.images || [];
            await this.service.render();
        }
    }

    public async refreshPreview() {
        // 전체 슬라이드를 PDF 뷰어처럼 세로로 쌓아 렌더 (slide_no 없이)
        this.previewUrl = `/wiz/api/page.presentation.detail/preview_html?deck_id=${this.deckId}&_=${Date.now()}`;
        this.safePreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewUrl);
        // PDF 미리보기 URL은 무효화 — PDF 탭 진입 시 다시 생성
        this.pdfPreviewUrl = '';
        this.safePdfPreviewUrl = null;
        if (this.previewTab === 'pdf') {
            await this.loadPdfPreview();
        }
        await this.service.render();
    }

    public async setPreviewTab(tab: 'html' | 'pdf') {
        if (this.previewTab === tab) return;
        this.previewTab = tab;
        if (tab === 'pdf' && !this.safePdfPreviewUrl) {
            await this.loadPdfPreview();
        }
        await this.service.render();
    }

    public async loadPdfPreview() {
        this.pdfPreviewLoading = true;
        await this.service.render();
        this.pdfPreviewUrl = `/wiz/api/page.presentation.detail/preview_pdf?deck_id=${this.deckId}&_=${Date.now()}`;
        this.safePdfPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfPreviewUrl);
        this.pdfPreviewLoading = false;
        await this.service.render();
    }

    // ───────── 인플레이스 편집 모드 ─────────

    public async enterHtmlEditMode() {
        if (this.htmlEditMode) return;
        // PDF 탭이면 HTML 탭으로 강제 전환
        this.previewTab = 'html';
        this.htmlEditMode = true;
        this.editablePreviewUrl = `/wiz/api/page.presentation.detail/preview_html_editable?deck_id=${this.deckId}&_=${Date.now()}`;
        this.safeEditablePreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.editablePreviewUrl);
        await this.service.render();
    }

    public async exitHtmlEditMode(save: boolean) {
        if (!this.htmlEditMode) return;
        if (!save) {
            this.htmlEditMode = false;
            this.editablePreviewUrl = '';
            this.safeEditablePreviewUrl = null;
            await this.service.render();
            await this.refreshPreview();
            return;
        }

        const editIframe = document.querySelector<HTMLIFrameElement>('iframe.edit-preview-frame');
        if (!editIframe || !editIframe.contentWindow) {
            await this.service.modal.show({ title: '오류', message: '편집 영역을 찾을 수 없습니다.', cancel: false, action: '확인' });
            return;
        }

        this.htmlEditSaving = true;
        await this.service.render();

        // postMessage 응답을 기다리며 슬라이드 데이터 수집
        const slidesData = await new Promise<any[]>((resolve) => {
            const onMessage = (event: MessageEvent) => {
                if (!event.data || event.data.type !== 'slidesData') return;
                window.removeEventListener('message', onMessage);
                resolve(event.data.slides || []);
            };
            window.addEventListener('message', onMessage);
            try {
                editIframe.contentWindow!.postMessage({ type: 'getSlides' }, '*');
            } catch (e) {
                window.removeEventListener('message', onMessage);
                resolve([]);
            }
            // 5초 타임아웃
            setTimeout(() => {
                window.removeEventListener('message', onMessage);
                resolve([]);
            }, 5000);
        });

        // dirty 슬라이드만 저장
        const dirtySlides = slidesData.filter((s: any) => s && s.dirty);
        if (dirtySlides.length === 0) {
            this.htmlEditSaving = false;
            this.htmlEditMode = false;
            this.editablePreviewUrl = '';
            this.safeEditablePreviewUrl = null;
            await this.service.render();
            return;
        }

        try {
            const res = await wiz.call('save_slide_body_html', {
                deck_id: this.deckId,
                slides: JSON.stringify(dirtySlides),
            });
            if (res.code !== 200) {
                await this.service.modal.show({ title: '저장 실패', message: res.data?.message || '저장 중 오류가 발생했습니다.', cancel: false, action: '확인' });
                this.htmlEditSaving = false;
                await this.service.render();
                return;
            }
        } catch (e) {
            await this.service.modal.show({ title: '저장 실패', message: String(e), cancel: false, action: '확인' });
            this.htmlEditSaving = false;
            await this.service.render();
            return;
        }

        this.htmlEditSaving = false;
        this.htmlEditMode = false;
        this.editablePreviewUrl = '';
        this.safeEditablePreviewUrl = null;
        await this.service.render();
        // 슬라이드 목록 다시 로드 (저장된 body_html 반영)
        await this.load();
    }

    // ───────── 우측 패널 탭 + AI 채팅 ─────────

    public async setRightTab(tab: 'edit' | 'chat') {
        if (this.rightTab === tab) return;
        this.rightTab = tab;
        await this.service.render();
    }

    public async clearChat() {
        this.chatMessages = [];
        await this.service.render();
    }

    public onChatEnter(event: KeyboardEvent) {
        // Shift+Enter는 줄바꿈, Enter는 전송
        if (event.shiftKey) return;
        event.preventDefault();
        if (this.chatLoading) return;
        if (!this.chatInput.trim()) return;
        this.sendChat();
    }

    public async sendChat() {
        const text = (this.chatInput || '').trim();
        if (!text) return;
        if (!this.currentSlide) {
            await this.service.modal.show({ title: '안내', message: '먼저 슬라이드를 선택하세요.', cancel: false, action: '확인' });
            return;
        }
        this.chatMessages.push({ role: 'user', text });
        this.chatInput = '';
        this.chatLoading = true;
        await this.service.render();

        try {
            const res = await wiz.call('chat_slide', {
                deck_id: this.deckId,
                slide_id: this.currentSlide.id,
                message: text,
            });
            if (res.code === 200) {
                this.currentSlide.body_html = res.data.body_html || this.currentSlide.body_html;
                this.currentSlide.status = 'ready';
                // 슬라이드 배열 내 인스턴스도 동기화
                const idx = this.slides.findIndex((s: any) => s.id === this.currentSlide.id);
                if (idx >= 0) this.slides[idx] = { ...this.slides[idx], body_html: this.currentSlide.body_html, status: 'ready' };
                this.chatMessages.push({ role: 'assistant', text: res.data.reply || '슬라이드를 수정했습니다.' });
                // 미리보기 자동 갱신
                await this.refreshPreview();
            } else {
                this.chatMessages.push({ role: 'assistant', text: `오류: ${res.data?.message || '수정에 실패했습니다.'}` });
            }
        } catch (e) {
            this.chatMessages.push({ role: 'assistant', text: `오류: ${String(e)}` });
        }

        this.chatLoading = false;
        await this.service.render();
    }

    public async openPreview() {
        // 새 탭: 전체 슬라이드 (slide_no 없이)
        const url = `/wiz/api/page.presentation.detail/preview_html?deck_id=${this.deckId}&_=${Date.now()}`;
        window.open(url, '_blank');
    }

    public async downloadPdf() {
        if (this.slides.length === 0) {
            await this.service.modal.show({ title: '안내', message: '슬라이드가 없습니다.', cancel: false, action: '확인' });
            return;
        }
        window.open(`/wiz/api/page.presentation.detail/download_pdf?deck_id=${this.deckId}`, '_blank');
    }

    public goBack() {
        if (this.deck?.notice_no) {
            this.service.href(`/presentation?notice_no=${encodeURIComponent(this.deck.notice_no)}`);
            return;
        }
        this.service.href('/presentation');
    }

    public goProjectAnalysis() {
        if (!this.deck?.notice_no) return;
        this.service.href(`/analysis/${encodeURIComponent(this.deck.notice_no)}?from=project`);
    }

    public goProjectProposal() {
        if (!this.deck?.notice_no) return;
        this.service.href(`/proposal/${encodeURIComponent(this.deck.notice_no)}`);
    }

    public statusLabel(s: string): string {
        const m: any = { draft: '대기', planning: '구성 중', writing: '작성 중', done: '완료' };
        return m[s] || s || '대기';
    }

    public statusClass(s: string): string {
        if (s === 'done') return 'bg-emerald-50 text-emerald-600 border border-emerald-200';
        if (s === 'writing' || s === 'planning') return 'bg-blue-50 text-blue-600 border border-blue-200';
        return 'bg-stone-100 text-stone-500';
    }

    public canRegen(): boolean {
        if (!this.currentSlide) return false;
        return this.currentSlide.layout !== 'agenda';
    }
}

export default PagePresentationDetailComponent;